import { render, staticRenderFns } from "./DataTableExpoCommodities.vue?vue&type=template&id=51323038&"
import script from "./DataTableExpoCommodities.vue?vue&type=script&lang=js&"
export * from "./DataTableExpoCommodities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports